import React, { useState, useEffect } from "react";
import styled from "styled-components";
import logo from "../images/logo.png";
import { Link, useLocation } from "react-router-dom";
import Fade from "react-reveal/Fade";

const Nav = styled.nav`
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  padding: 1rem;
  top: -1px;
  padding: 0px 20%;
  ${(props) => props.color && "filter: drop-shadow(0px 3px 5px #363535);"}
  ${(props) =>
    props.color
      ? "background-color: #3b4f95;"
      : "background-color: rgba(38, 50, 110, 0.5);"}
  @media (max-width: 900px) {
    padding: 0;
    height: 60px;
  }
`;

const Logo = styled.div`
  img {
    height: 30px;
    @media (max-width: 900px) {
      height: 20px;
    }
  }
`;

const Menu = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  width: 40%;
  height: 100%;
  align-items: center;
  li {
    width: 33.33%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    &:hover {
      border-top: solid 5px #6087b9;
    }
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
  @media (max-width: 900px) {
    width: 60%;
  }
`;
const Test = styled.div`
  position: sticky;
  z-index: 999;
  top: -1px;
`;

const NewBar = styled.div`
  position: absolute;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: #2a4196;
  display: column;
  right: 2px;
  top: 100%;
  width: 150px;
  justify-content: space-between;
  text-align: center;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  a {
    text-decoration: none;
    font-family: "Jost", sans-serif;
    font-weight: 300;
    color: white;
    margin-bottom: 5px;
  }
`;

function TopNav({ limit }) {
  const [sticky, setSticky] = useState(false);
  const location = useLocation().pathname.replace("/", "");

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > (limit !== undefined ? limit : -1)) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [limit]);

  return (
    <Test>
      {sticky ? (
        <Fade top>
          <Nav color={sticky}>
            <Link to={"/"}>
              <Logo>
                <img src={logo} alt="logo" />
              </Logo>
            </Link>
            <Menu>
              <TopPaths location={location} name={""}>
                <Link to={"/"}>Início</Link>
              </TopPaths>
              <TopPaths location={location} name={"sobre"}>
                <Link to={"/sobre"}>Sobre mim</Link>
              </TopPaths>{" "}
              <TopPaths location={location} name={"contato"}>
                <Link to={"/contato"}>Contato</Link>
              </TopPaths>{" "}
            </Menu>
            <NewBar>
              <a href="https://api.whatsapp.com/send?phone=5511917721058&text=Olá%20Quero%20saber%20mais%20Sobre%20Clínica%20de%20Recuperação">
                <p>(11)917721058</p>
              </a>
            </NewBar>
          </Nav>
        </Fade>
      ) : (
        <Nav color={sticky}>
          <Link to={"/"}>
            <Logo>
              <img src={logo} alt="logo" />
            </Logo>
          </Link>
          <Menu>
            <TopPaths location={location} name={""}>
              <Link to={"/"}>Início</Link>
            </TopPaths>
            <TopPaths location={location} name={"sobre"}>
              <Link to={"/sobre"}>Sobre mim</Link>
            </TopPaths>{" "}
            <TopPaths location={location} name={"contato"}>
              <Link to={"/contato"}>Contato</Link>
            </TopPaths>{" "}
          </Menu>
        </Nav>
      )}
    </Test>
  );
}

export default TopNav;

const TopPaths = styled.li`
  border-top: ${(props) =>
    props.location === props.name && "solid 5px #6087b9"};
  a {
    text-decoration: none;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    color: white;
  }
`;
